import { DecimalPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SharedService } from 'src/app/shared.service';
import swal from 'sweetalert';

@Component({
  selector: 'app-add-edit-employee',
  templateUrl: './add-edit-employee.component.html',
  styleUrls: ['./add-edit-employee.component.scss']
})
export class AddEditEmployeeComponent implements OnInit {

  constructor(private service: SharedService) { }

  @Input() emp:any;

  pkEmpId!: number;
  FirstName!: string;
  LastName!: string;
  Gender!: string;
  Age!: number;
  EmpEmail!: string;
  Designation!: string;
  ContactNumber!: string;
  CasualLeaveBalance!: number;
  AnnualLeaveBalance!: number;
  IsPermanent!: boolean;
  ClockifyId!: string;
  OnLeave!: boolean;
  MaternityLimit!: number;

  ngOnInit(): void 
  {
    this.pkEmpId = this.emp.pkEmpId,
    this.FirstName = this.emp.FirstName,
    this.LastName = this.emp.LastName,
    this.Gender =  this.emp.Gender == undefined ? "Male" : this.emp.Gender,
    this.Age = this.emp.Age,
    this.EmpEmail = this.emp.EmpEmail,
    this.Designation = this.emp.Designation,
    this.ContactNumber = this.emp.ContactNumber,
    this.CasualLeaveBalance = this.emp.CasualLeaveBalance,
    this.AnnualLeaveBalance = this.emp.AnnualLeaveBalance,
    this.IsPermanent =  this.emp.IsPermanent == undefined ? false : this.emp.IsPermanent,
    this.ClockifyId = this.emp.ClockifyId,
    this.OnLeave = false,
    this.MaternityLimit = 0

  }


  Test()
  {
    console.log(this.emp)
  }


  AddEmployee()
  {
    var val = 
    {
      pkEmpId: this.pkEmpId,
      FirstName: this.FirstName,
      LastName: this.LastName,
      Gender: this.Gender,
      Age: this.Age,
      EmpEmail: this.EmpEmail,
      Designation: this.Designation,
      ContactNumber: this.ContactNumber,
      CasualLeaveBalance: this.CasualLeaveBalance,
      AnnualLeaveBalance: this.AnnualLeaveBalance,
      IsPermanent: this.IsPermanent,
      ClockifyId: this.ClockifyId,
      OnLeave: 0,
      MaternityLimit: 0
    };
    this.service.AddEmployee(val).subscribe(res =>
      {
        swal("Success", `${res}`, "success")
      }, err =>
      {
        console.log(err);
        swal("Failure", `${err.error.title || err.error.errors}`, "error")
      });
  }


  UpdateEmployee()
  {
    var val = 
    {
      pkEmpId: this.pkEmpId,
      FirstName: this.FirstName,
      LastName: this.LastName,
      Gender: this.Gender,
      Age: this.Age,
      EmpEmail: this.EmpEmail,
      Designation: this.Designation,
      ContactNumber: this.ContactNumber,
      CasualLeaveBalance: this.CasualLeaveBalance,
      AnnualLeaveBalance: this.AnnualLeaveBalance,
      IsPermanent: this.IsPermanent,
      ClockifyId: this.ClockifyId,
      OnLeave: 0,
      MaternityLimit: 0
    };
    this.service.UpdateEmployee(val).subscribe(res =>
      {
        swal("Success", `${res}`, "success")
      }, err =>
      {
        console.log(err.error.errors);
        swal("Failure", `${err.error.title} Please make sure all fields are filled correctly.`, "error")
      });
  }

}


